import { render, staticRenderFns } from "./WeightInput.vue?vue&type=template&id=165e4220"
import script from "./WeightInput.vue?vue&type=script&lang=ts"
export * from "./WeightInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports